module.exports = __webpack_public_path__ + "static/img/it2.9e666d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/it2.png
// module id = 8giS
// module chunks = 0